/* eslint-disable */
import { Injectable } from '@angular/core';

@Injectable()
export class LocalStorageService {
  /**
   * Get all or some of data out of localstorage.
   * @public
   * @param {?}   arguments   - the groups or keys names.
   * @return      object      - the groups or keys values.
   */
  get(...args) {
    const storage = {};
    if (args.length !== 0) { // get values of given args.
      for (let arg in args) {
        try {
          storage[args[arg]] = JSON.parse(localStorage.getItem(args[arg]));
        }
        catch (e) {
          storage[args[arg]] = localStorage.getItem(args[arg]);
        }
      }
    // if not receive any arguments returns all storage values.
    } else { 
      for (let i = localStorage.length - 1; i >= 0; i--) {
        try {
          storage[localStorage.key(i)] = JSON.parse(localStorage.getItem(localStorage.key(i)));
        }
        catch (e) {
          storage[localStorage.key(i)] = localStorage.getItem(localStorage.key(i));
        }
      }
    }
    return storage;
  }

  /**
   * Finds a key in local storage.
   * @public
   * @param {String}    key     - Name of the key.
   * @return {?}      data    - The key and its value.
   */
  getItem(key) {
    if (key) {
      try {
        return JSON.parse(localStorage.getItem(key));
      }
      catch (e) {
        return localStorage.getItem(key);
      }
    }
  }

  /**
   * Updates a value of a key by key and or group name.
   * @public
   * @param {String}  key     - Name of the key.
   * @param {?}   value   - The new data.
   * @param {String}  groupName - Name of the group.
   */
  updateItem(key, value, groupName) {
    let storage;
    if (groupName) {
      storage = this.get(groupName);
      storage[groupName][key] = value;
      localStorage.setItem(groupName, JSON.stringify(storage[groupName]));
    } else {
      storage = this.get(key);
      storage[key] = value;
      localStorage.setItem(key, JSON.stringify(storage[key]));
    }
  }

  /**
   * Creates new key and value
   * @public
   * @param {String}  key     - Name of the key.
   * @param {?}   value   - The new data.
   */
  setItem(key, value) {
    if (typeof value === 'object') {
      value = JSON.stringify(value);
    }
    localStorage.setItem(key, value);
  }

  /**
   * Deletes a key.
   * @public
   * @param {String}    key   - The key for an event.
   */
  removeItem(key) {
    localStorage.removeItem(key);
  }

  /**
   * Deletes everything in local storage.
   * @public
   */
  clear() {
    localStorage.clear();
  }

}
